{
	"title": "Declaraciones",
	"table": {
		"material": "Material",
		"dateOfIssue": "Fecha de emisión",
		"quantity": "Cantidad",
		"carbonSavings": "Reducciones de carbono",
		"status": {
			"title": "Estado",
			"TransactionProcessing": "Procesamiento de transacciones",
			"CreatingDeclaration": "Creando declaración",
			"GenerationFailed": "Generación fallida",
			"ReadyToDownload": "Listo para descargar"
		}
	},
	"declarationLanguageSelect": {
		"title": "Idioma de declaración",
		"description": "Seleccione un idioma de declaración.",
		"label": "Idioma de declaración",
		"buttonBack": "Atrás",
		"buttonSave": "Guardar"
	},
	"downloadAllLanguageSelect": {
		"title": "Idiomas de declaración",
		"descriptionGlobal": "Seleccione un idioma para todas las declaraciones.",
		"descriptionIndividual": "O configure el idioma para cada declaración individualmente.",
		"label": "Idiomas de declaración",
		"tableHeaderDeclaration": "Declaración (material/fecha de emisión)",
		"tableHeaderLanguage": "Idioma de declaración",
		"buttonBack": "Atrás",
		"buttonDownload": "Descargar declaraciones"
	},
	"declarationActions": {
		"changeLanguage": "Cambiar idioma de declaración",
		"preview": "Vista previa",
		"download": "Descargar",
		"transaction": "Transacción",
		"showMoreTransactions": "Mostrar más transacciones",
		"languageLabel": "Idioma de declaración",
		"downloadAll": "Descargar todas las declaraciones"
	}
}
